import { createContext, useContext, useCallback } from 'react'
import { TR, LANG_META } from './translations'

export const I18nCtx = createContext(null)

export function useT() {
  const { t } = useContext(I18nCtx)
  return t
}

export function useLang() {
  return useContext(I18nCtx)
}

export function I18nProvider({ lang = 'en', children }) {
  const t = useCallback((key, vars = {}) => {
    const entry = TR[key]
    if (!entry) return key
    const str = entry[lang] || entry['en'] || key
    return str.replace(/\{(\w+)\}/g, (_, v) => vars[v] ?? `{${v}}`)
  }, [lang])

  return (
    <I18nCtx.Provider value={{ lang, t, meta: LANG_META[lang] }}>
      {children}
    </I18nCtx.Provider>
  )
}
